/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { whatsAppAiAgentConfigApprove } from '../../axios/whatsAppAiAgentConfigApprove'
import type {
	WhatsAppAiAgentConfigApproveError,
	WhatsAppAiAgentConfigApprovePathParams,
	WhatsAppAiAgentConfigApproveResponse,
} from '../../types/WhatsAppAiAgentConfigApprove'

export const whatsAppAiAgentConfigApproveMutationKey = () =>
	[{ url: '/campaigns/:campaignId/whatsapp-ai-config/approve' }] as const

export type WhatsAppAiAgentConfigApproveMutationKey = ReturnType<typeof whatsAppAiAgentConfigApproveMutationKey>

export type WhatsAppAiAgentConfigApproveVariables = {
	campaignId: WhatsAppAiAgentConfigApprovePathParams['campaignId']
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAiAgentConfigController.php WhatsAppAiAgentConfigController::approve */
export function useWhatsAppAiAgentConfigApprove<TContext = unknown>(
	options?: UseMutationOptions<
		WhatsAppAiAgentConfigApproveResponse,
		AxiosError<WhatsAppAiAgentConfigApproveError>,
		WhatsAppAiAgentConfigApproveVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: whatsAppAiAgentConfigApproveMutationKey(),
		mutationFn: ({ campaignId }: WhatsAppAiAgentConfigApproveVariables) =>
			whatsAppAiAgentConfigApprove(campaignId, config).then(res => res.data),
		...options,
	})
}
